import { render } from "./wage-result-statistics.vue?vue&type=template&id=12d74b41"
import script from "./wage-result-statistics.vue?vue&type=script&lang=js"
export * from "./wage-result-statistics.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/wagesetting/wage-result-statistics.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12d74b41"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12d74b41', __exports__)) {
    api.reload('12d74b41', __exports__)
  }
  
  module.hot.accept("./wage-result-statistics.vue?vue&type=template&id=12d74b41", () => {
    api.rerender('12d74b41', render)
  })

}


export default __exports__